import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SearchBox from './SearchBox';
import Menu from './Menu';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { openMiniCart, getCartItemsCount } = useCart();
  const { isAuthenticated, openLoginModal, logout } = useAuth();

  return (
    <header className="header">
      <nav className="nav">
        {/* Mobile Menu Button - Left side */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            fontSize: '1.2rem',
            padding: '0.5rem'
          }}
          className="mobile-menu-btn-left"
        >
          ☰
        </button>

        <Link to="/" className="logo">
          SimpleShop
        </Link>

        {/* Desktop Search */}
        <div style={{ flex: 1, maxWidth: '400px', margin: '0 2rem' }} className="desktop-search">
          <SearchBox />
        </div>

        <ul className="nav-links">
          <li className="mobile-search-btn">
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              style={{
                background: 'none',
                border: 'none',
                color: 'white',
                cursor: 'pointer',
                fontSize: '1.2rem',
                padding: '0.5rem'
              }}
            >
              🔍
            </button>
          </li>
          <li className="desktop-only"><Link to="/">Home</Link></li>
          {/* User Account */}
          <li>
            {isAuthenticated ? (
              <Link
                to="/my-account"
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  cursor: 'pointer',
                  textDecoration: 'none',
                  padding: '0.5rem',
                  display: 'flex',
                  alignItems: 'center'
                }}
                title="My Account"
                className="user-account-link"
              >
                <svg className="mobile-user-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                <span className="desktop-user-text">My Account</span>
              </Link>
            ) : (
              <button
                onClick={openLoginModal}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  cursor: 'pointer',
                  padding: '0.5rem',
                  display: 'flex',
                  alignItems: 'center'
                }}
                title="Sign In"
                className="user-account-btn"
              >
                <svg className="mobile-user-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                <span className="desktop-user-text">Sign In</span>
              </button>
            )}
          </li>
          <li>
            <button
              onClick={openMiniCart}
              style={{
                background: 'none',
                border: 'none',
                color: 'white',
                cursor: 'pointer',
                fontSize: '1.2rem',
                position: 'relative'
              }}
            >
              🛒
              {getCartItemsCount() > 0 && (
                <span
                  style={{
                    position: 'absolute',
                    top: '-8px',
                    right: '-8px',
                    backgroundColor: '#ef4444',
                    color: 'white',
                    borderRadius: '50%',
                    width: '20px',
                    height: '20px',
                    fontSize: '0.75rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 'bold'
                  }}
                >
                  {getCartItemsCount()}
                </span>
              )}
            </button>
          </li>
        </ul>
      </nav>

      {/* Desktop Horizontal Menu */}
      <div
        style={{
          borderTop: '1px solid rgba(255,255,255,0.1)',
          padding: '0 1rem'
        }}
        className="desktop-menu"
      >
        <Menu />
      </div>

      {/* Mobile Menu */}
      <Menu
        isMobile={true}
        isOpen={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
      />

      {/* Mobile Search Overlay */}
      {searchOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: 'white',
          padding: '1rem',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          zIndex: 1000
        }}>
          <SearchBox onClose={() => setSearchOpen(false)} />
        </div>
      )}
    </header>
  );
};

export default Header;